import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Spin, Typography, message } from "antd";
import { useAuthStore } from "@/stores/auth";
import { authService } from "@/services/auth";

const { Text } = Typography;

export function SsoCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setTokens, setUser } = useAuthStore();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const orgId = sessionStorage.getItem("sso_org_id");

    if (!code || !state) {
      setError("Missing code or state parameter");
      return;
    }
    if (!orgId) {
      setError("Missing organization context (session expired)");
      return;
    }

    authService.ssoExchangeToken(orgId, code, state)
      .then((result) => {
        sessionStorage.removeItem("sso_org_id");
        setTokens(result.tokens.access_token, result.tokens.refresh_token);
        setUser(result.user);
        message.success("SSO login successful");
        navigate("/management", { replace: true });
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : "SSO token exchange failed");
      });
  }, [searchParams, navigate, setTokens, setUser]);

  if (error) {
    return (
      <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
        <Text type="danger">{error}</Text>
        <a href="/login">Back to login</a>
      </div>
    );
  }

  return (
    <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
      <Spin size="large" />
      <Text type="secondary">Completing SSO login...</Text>
    </div>
  );
}
